module.exports = __webpack_public_path__ + "img/design_manager.418c0821.jpg";